import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// We keep ChevronRight for the "View Full Menu" button only.
import { ChevronRight } from 'lucide-react';
import { db } from '../firebase'; // Your Firebase config file
import { doc, getDoc } from 'firebase/firestore';

const EnhancedFoodCarousel = () => {
  // State to hold the carousel items fetched from Firestore
  const [carouselItems, setCarouselItems] = useState([]);

  // Function to fetch carousel data from Firestore
  const fetchCarouselItems = async () => {
    // Reference to the EndlessCarousel document in menuCategories collection
    const docRef = doc(db, 'menuCategories', 'EndlessCarousel');
    try {
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        // Update state with the fetched items
        setCarouselItems(docSnap.data().items);
      } else {
      }
    } catch (error) {
   
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchCarouselItems();
  }, []);

  // Duplicate the items once for a seamless infinite scroll effect
  const duplicatedItems = [...carouselItems, ...carouselItems];

  return (
    <div className="relative bg-black py-8" role="region" aria-label="Food categories carousel">
      {/* Carousel Container */}
      <div className="overflow-hidden relative">
        {/* The inner div always uses the animate-scroll class to continuously scroll */}
        <div className="inline-flex whitespace-nowrap animate-scroll">
          {duplicatedItems.map((item, index) => (
            <Link
              to={`/menu/${item.title.toLowerCase()}`}
              key={`${item.id}-${index}`}
              className="group flex-none w-80 p-4"
              aria-label={`View ${item.title} menu items`}
            >
              <div className="overflow-hidden rounded-lg bg-gray-900 shadow-xl transition-all duration-300 group-hover:shadow-red-500/50">
                <div className="relative h-48">
                  <img
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    src={item.src}
                    alt={item.title}
                    loading="lazy"
                    decoding="async"
                  />
                  {/* Overlay appears on hover */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
                <div className="p-4 bg-black border-t border-red-500">
                  <h3 className="text-red-500 text-xl font-bold">{item.title}</h3>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* "View Full Menu" Button remains */}
      <div className="mt-8 text-center">
        <Link
          to="/menu/breakfast"
          className="inline-flex items-center px-6 py-3 bg-red-500 text-white font-bold rounded-lg hover:bg-red-600 transition-all duration-300 hover:scale-105"
        >
          View Full Menu
          <ChevronRight className="ml-2 w-5 h-5" />
        </Link>
      </div>

      {/* CSS for scrolling animation */}
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-scroll {
          animation: scroll 50s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default EnhancedFoodCarousel;
